var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import ReactDom from "react-dom";
import useUniqueId from "../../Hooks/useUniqueId";
import useIsInModal, { IsInModalContextProvider, } from "../../Hooks/useIsInModal";
// @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'keyof ModalProps[]'.
export const ModalTypePropKeys = [
    "modalId",
    "isOpen",
    "onModalClosed",
    "children",
    "keyboard",
    "backdrop",
    "size",
    "focus",
    "className",
    "style",
    "isInModal",
    "appendToBody",
    "unMountContentWhenClosed",
];
const Modal = (_a) => {
    var { modalId, isOpen, onModalClosed, children, keyboard, backdrop, focus, size, appendToBody, style, unMountContentWhenClosed, contentRef } = _a, otherProps = __rest(_a, ["modalId", "isOpen", "onModalClosed", "children", "keyboard", "backdrop", "focus", "size", "appendToBody", "style", "unMountContentWhenClosed", "contentRef"]);
    const modalElement = useRef(null);
    const makeId = useUniqueId()[1];
    const safeModalId = React.useMemo(() => modalId || makeId("modal"), [makeId, modalId]);
    const config = {
        "data-keyboard": keyboard,
        "data-backdrop": backdrop,
        "data-focus": focus,
    };
    const isInModal = useIsInModal();
    useEffect(() => {
        modalElement.current = $("#" + safeModalId);
        modalElement.current.on("hide.bs.modal", () => {
            onModalClosed();
        });
        modalElement.current.on("hidden.bs.modal", () => {
            if (isInModal) {
                document.body.classList.add("modal-open");
            }
        });
        return () => {
            modalElement.current.off("hide.bs.modal");
            modalElement.current.off("hidden.bs.modal");
        };
    }, [safeModalId, onModalClosed, isInModal]);
    useEffect(() => {
        if (isOpen) {
            if (modalElement.current) {
                modalElement.current.modal("show");
            }
        }
        else if (modalElement.current) {
            modalElement.current.modal("hide");
        }
        return () => {
            if (modalElement.current) {
                modalElement.current.modal("hide");
            }
        };
    }, [isOpen]);
    const modalStyles = style || {};
    if (isInModal) {
        // apply a z-index so this modal appears over the other modal, and give it a background color so there's
        // a distinction between this modal and the one it's in.
        modalStyles.zIndex = 1600;
        modalStyles.backgroundColor = "rgba(0,0,0,0.5)";
    }
    let shouldShowBody = true;
    if (unMountContentWhenClosed) {
        // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean'.
        shouldShowBody = isOpen;
    }
    const modal = (
    // $FlowFixMe - it's ok if '...otherProps' interferes with the attributes above it
    _jsx("div", Object.assign({ 
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number | undefined'.
        tabIndex: "-1", role: "dialog", "aria-hidden": !isOpen, style: modalStyles }, otherProps, { id: safeModalId, className: `modal fade ${otherProps.className ? otherProps.className : ""}` }, config, { children: _jsx("div", { className: "modal-dialog " + (size ? "modal-" + size : ""), role: "document", children: _jsx("div", { className: "modal-content", ref: contentRef, children: _jsx(IsInModalContextProvider, { children: shouldShowBody && (children || null) }) }) }) })));
    // Append this to the body if append to body is explicitly set, or if this modal is in another modal
    return appendToBody || isInModal
        ? ReactDom.createPortal(modal, 
        // $FlowFixMe -- assume that we will always have a body tag
        document.body)
        : modal;
};
Modal.defaultProps = {
    appendToBody: true,
};
export default Modal;
